<template>
    <div class="row">
        <div class="col-md-12 card-wrapper">
            <div class="card">
                <div class="card-header crm-modal-header hpx-50 d-flex align-items-center">
                    Entegrasyonlar <i class="fas fa-info-circle ml-2" style="color: #53565E;"></i>
                </div>
                <div class="card-body bg-light color-gray">
                    <div class="container">
                        <div class="row" v-if="showCards">
                            <div class="grid-item col-md-4 m-2" @click="changeCloudType('im-sms')">
                                <span v-if="im_sms_active" class="card-active" style="color:#2ED912;"><i class="fas fa-circle"></i></span>
                                <span v-else class="card-active" style="color:#DFE1DE;"><i class="fas fa-circle"></i></span>

                                <img src="@/assets/iletisim_makinesi_logo.png" class="img-fluid py-2">
                                <p>İletişim Makinesi - SMS</p>
                            </div>
                            <div class="grid-item col-md-4 m-2" @click="changeCloudType('im-email')">
                                <span v-if="im_mail_active" class="card-active" style="color:#2ED912;"><i class="fas fa-circle"></i></span>
                                <span v-else class="card-active" style="color:#DFE1DE;"><i class="fas fa-circle"></i></span>

                                <img src="@/assets/iletisim_makinesi_logo.png" class="img-fluid py-2">
                                <p>İletişim Makinesi - Mail</p>
                            </div>
                            <div class="grid-item col-md-4 m-2" @click="changeCloudType('whatsapp')">
                                <span v-if="whatsapp_active" class="card-active" style="color:#2ED912;"><i class="fas fa-circle"></i></span>
                                <span v-else class="card-active" style="color:#DFE1DE;"><i class="fas fa-circle"></i></span>

                                <img src="@/assets/64whatsapp.png" class="img-fluid py-2">
                                <p>WhatsApp</p>
                            </div>
                        </div>

                        <!-- İletişim Makinesi Formu -->
                        <div class="row" v-if="show_im_integration">
                            <div class="col-md-12">
                                <h6>{{headerText}}</h6>
                            </div>
                            <div class="col-md-6">
                                <div>
                                    <label class="new-label">Hesap Adı*</label>
                                    <input type="text" v-model="accountName" placeholder="IM-Email" class="new-input" />
                                </div>                    
                                <div>
                                    <label class="new-label">Iys Transaction Type</label>
                                    <select class="new-input" v-model="iysTransactionType">
                                        <option disabled value="">{{$ml.get('CHOOSE')}}</option>
                                        <option value="reklam">Reklam</option>
                                        <option value="bilgilendirme">Bilgilendirme</option>
                                    </select>
                                </div>
                                <div>
                                    <label class="new-label">Originator Id*</label>
                                    <input type="text" v-model="originatorId" placeholder="" class="new-input" />
                                </div>
                                <div>
                                    <label class="new-label">Token</label>
                                    <input type="text" v-model="token" placeholder="" class="new-input" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div>
                                    <label class="new-label">Hesap Email*</label>
                                    <input type="text" v-model="accountEmail" placeholder="askin@askin.ws" class="new-input" />
                                </div>
                                <div>
                                    <label class="new-label">Iys Brand Code</label>
                                    <input type="text" class="new-input" v-model="iysBrandCode"/>
                                </div>
                                <div>
                                    <label class="new-label">Iys Recipient Type</label>
                                    <select class="new-input" v-model="iysRecipientType">
                                        <option disabled value="">{{$ml.get('CHOOSE')}}</option>
                                        <option value="birey">Birey</option>
                                        <option value="tacir">Tacir</option>
                                    </select>
                                </div>                                
                            </div>
                            <div class="col-md-12 mt-3 d-flex justify-content-end">
                                <button class="btn btn-light" @click="clear()">İptal</button>
                                <button v-if="updateMode" class="btn btn-danger ml-1" @click="deleteCloudApiTokenF">Delete</button>
                                <button v-if="updateMode" class="btn bg-new-primary w-150p ml-1" @click="updateCloudApiTokenF">{{$ml.get('EDIT')}}</button>
                                <button v-else class="btn bg-new-primary w-150p ml-1" @click="saveCloudApiTokenF">{{$ml.get('SAVE')}}</button>
                            </div>
                        </div>

                        <!-- WhatsApp Entegrasyon Seçenekleri (Cloud API + Coexistence) -->
                        <div class="row" v-if="show_wp_integration">
                            <div class="col-md-12 mb-3">
                                <h6>{{headerText}} Entegrasyonu</h6>
                            </div>

                            <!-- Aktif Bağlantı Varsa -->
                            <div class="col-md-12" v-if="whatsapp_active">
                                <div class="alert alert-success d-flex align-items-center justify-content-between">
                                    <span><i class="fas fa-check-circle mr-2"></i> WhatsApp hesabınız şu anda aktif ve bağlı durumda.</span>
                                    <button class="btn btn-danger btn-sm" :disabled="whatsappDisconnecting" @click="disconnectWhatsApp">
                                        {{ whatsappDisconnecting ? 'Bağlantı kesiliyor...' : 'Bağlantıyı Kes' }}
                                    </button>
                                </div>
                            </div>

                            <!-- Aktif Bağlantı Yoksa İki Seçeneği Göster -->
                            <template v-else>
                                <!-- Seçenek 1: Standart Cloud API -->
                                <div class="col-md-6 mb-3">
                                    <div class="wp-option-card p-3 h-100 d-flex flex-column justify-content-between">
                                        <div>
                                            <h6 class="font-weight-bold text-dark">
                                                <i class="fas fa-cloud text-primary mr-1"></i> Standart Cloud API
                                            </h6>
                                            <p class="small text-muted mt-2">
                                                Numaranızı <strong>sadece CRM üzerinden</strong> kullanmak için bu seçeneği tercih edin. 
                                                Yeni bir numara ekleyebilir veya sadece API üzerinde çalışacak bir hat tanımlayabilirsiniz.
                                            </p>
                                        </div>
                                        <button class="btn btn-success btn-block mt-2" 
                                                :disabled="facebookLoginLoading" 
                                                @click="openWhatsappSignup(false)">
                                            {{ facebookLoginLoading && !selectedCoexMode ? 'Facebook açılıyor...' : 'Standart Cloud API ile Bağlan' }}
                                        </button>
                                    </div>
                                </div>

                                <!-- Seçenek 2: Coexistence (Mobil Uygulama + CRM) -->
                                <div class="col-md-6 mb-3">
                                    <div class="wp-option-card p-3 h-100 d-flex flex-column justify-content-between" style="border-color: #25D366;">
                                        <div>
                                            <div class="d-flex align-items-center justify-content-between">
                                                <h6 class="font-weight-bold text-dark mb-0">
                                                    <i class="fas fa-mobile-alt text-success mr-1"></i> Coexistence (Mobil + CRM)
                                                </h6>
                                                <span class="badge badge-success">Önerilen</span>
                                            </div>
                                            <p class="small text-muted mt-2">
                                                Telefonunuzdaki <strong>WhatsApp Business uygulamasını kapatmadan</strong> hem cepten hem CRM'den aynı anda kullanın. 
                                                QR kod ile son 6 aylık sohbet geçmişiniz ve rehberiniz otomatik aktarılır.
                                            </p>
                                        </div>
                                        <button class="btn btn-outline-success btn-block mt-2 font-weight-bold" 
                                                :disabled="facebookLoginLoading" 
                                                @click="openWhatsappSignup(true)">
                                            {{ facebookLoginLoading && selectedCoexMode ? 'Facebook açılıyor...' : 'WhatsApp Business App ile Eşleştir (Coex)' }}
                                        </button>
                                    </div>
                                </div>
                            </template>
                           
                            <div class="col-md-12 mt-3 d-flex justify-content-end">
                                <button class="btn btn-light" @click="clear()">İptal</button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        
        <notifications group="foo" style="margin-right:5%;margin-top:5%" position="top right" />
    </div>
</template>

<script>
import { mapState } from 'vuex'
import axios from 'axios'

export default {
    name: 'thirdPartySettings',
    data() {
        return {
            apiTokensList: [],
            accountName: '',
            cloudType: '',
            accountEmail: '',
            cloudApiToken: '',
            iysBrandCode: '',
            iysTransactionType: '',
            iysRecipientType: '',
            originatorId: '',
            token: '',
            headerText: '',
            accountId: '',
            showCards: true,
            show_im_integration: false,
            show_wp_integration: false,
            im_sms_active: false,
            im_mail_active: false,
            whatsapp_active: false,
            whatsappAccountId: '',
            updateMode: false,
            fbReady: false,
            facebookLoginLoading: false,
            whatsappDisconnecting: false,
            // Coexistence & Embedded Signup Oturum Bilgileri
            selectedCoexMode: false,
            waSessionInfo: {
                phone_number_id: null,
                waba_id: null,
                event_type: null
            }
        }
    },
    computed: {
        ...mapState([
            'baseUrl'
        ]),
    },
    methods: {
        // -------------------------------------------------------------
        // WHATSAPP EMBEDDED SIGNUP (STANDART + COEXISTENCE)
        // -------------------------------------------------------------
        handleMetaPopupMessage(event) {
            if (event.origin !== "https://www.facebook.com" && event.origin !== "https://web.facebook.com") {
                return;
            }
            try {
                const data = JSON.parse(event.data);
                if (data.type === 'WA_EMBEDDED_SIGNUP') {
                    console.log("Meta Embedded Signup Event:", data);
                    // Hem standart FINISH hem de Coexistence FINISH_WHATSAPP_BUSINESS_APP_ONBOARDING event'ini yakalar
                    if (data.event === 'FINISH' || data.event === 'FINISH_WHATSAPP_BUSINESS_APP_ONBOARDING') {
                        if (data.data) {
                            this.waSessionInfo.phone_number_id = data.data.phone_number_id || null;
                            this.waSessionInfo.waba_id = data.data.waba_id || null;
                            this.waSessionInfo.event_type = data.event;
                        }
                    }
                }
            } catch (e) {
                // JSON olmayan diğer fb mesajlarını yoksay
            }
        },

        waitForFacebookSdk() {
            if (window.FB) {
                this.fbReady = true
                return Promise.resolve(window.FB)
            }

            return new Promise((resolve) => {
                const onReady = () => {
                    cleanup()
                    this.fbReady = Boolean(window.FB)
                    resolve(window.FB || null)
                }
                const timeout = window.setTimeout(() => {
                    cleanup()
                    resolve(null)
                }, 10000)
                const cleanup = () => {
                    document.removeEventListener('fb-sdk-ready', onReady)
                    window.clearTimeout(timeout)
                }

                document.addEventListener('fb-sdk-ready', onReady)
            })
        },

        async openWhatsappSignup(isCoex = false) {
            this.selectedCoexMode = isCoex;
            this.facebookLoginLoading = true;
            const facebook = await this.waitForFacebookSdk();
            this.facebookLoginLoading = false;

            if (!facebook) {
                this.$notify({ group: "foo", type: "error", text: "Facebook bağlantısı yüklenemedi. Lütfen sayfayı yenileyip tekrar deneyin." });
                return;
            }

            // Her kurulum denemesinde oturum bilgilerini sıfırla
            this.waSessionInfo = { phone_number_id: null, waba_id: null, event_type: null };

            // Seçilen moda göre Facebook Login ayarlarını hazırla
            const loginOptions = {
                config_id: "2250130195429058", // Facebook Business Manager’dan
                response_type: "code",
                override_default_response_type: true,
                extras: {
                    sessionInfoVersion: "3"
                }
            };

            // Eğer müşteri Coexistence (Mobil Uygulama ile birlikte kullanım) seçtiyse featureType ekle
            if (isCoex) {
                loginOptions.extras.featureType = "whatsapp_business_app_onboarding";
            }

            facebook.login(
                (response) => {
                    console.log("window.FB.login response", response);
                    if (response.authResponse && response.authResponse.code) {
                        const authCode = response.authResponse.code;
                        console.log("Auth Code:", authCode);
                        console.log("WA Session Info:", this.waSessionInfo);

                        // Hem kullanıcının seçtiği buton hem de Meta'dan dönen event tipine göre Coex kontrolü
                        const finalIsCoex = isCoex || this.waSessionInfo.event_type === 'FINISH_WHATSAPP_BUSINESS_APP_ONBOARDING';

                        axios({
                            method: 'POST',
                            url: '/metaLogin',
                            baseURL: this.baseUrl,
                            data: {
                                code: authCode,
                                is_coex: finalIsCoex,
                                phone_number_id: this.waSessionInfo.phone_number_id,
                                waba_id: this.waSessionInfo.waba_id
                            },
                            withCredentials: true
                        }).then((res) => {
                            if (res.data && res.data.status && String(res.data.status.code) === '0') {
                                this.$notify({ 
                                    group: 'foo', 
                                    type: 'success', 
                                    text: finalIsCoex ? 'WhatsApp Coexistence bağlantısı kuruldu.' : 'WhatsApp Cloud API bağlantısı kuruldu.' 
                                });
                                this.getCloudApiTokensF();
                                this.clear();
                            } else {
                                this.$notify({ 
                                    group: 'foo', 
                                    type: 'error', 
                                    text: (res.data && res.data.status && res.data.status.desc) || 'WhatsApp bağlantısı kurulamadı.' 
                                });
                            }
                        }).catch(() => {
                            this.$notify({ group: 'foo', type: 'error', text: 'WhatsApp bağlantısı kurulamadı.' });
                        });
                    } else {
                        console.log("Kullanıcı iptal etti.");
                    }
                },
                loginOptions
            );
        },
        // -------------------------------------------------------------
        // WHATSAPP END
        // -------------------------------------------------------------

        checkIntegrations(data) {
            this.im_sms_active = false
            this.im_mail_active = false
            this.whatsapp_active = false
            this.whatsappAccountId = ''
            for(let item of data){
                if(item.cloud_type === 'im-sms'){
                    this.im_sms_active = true
                }
                else if(item.cloud_type === 'im-email'){
                    this.im_mail_active = true
                }
                else if(item.cloud_type === 'whatsapp'){
                    this.whatsapp_active = true
                    this.whatsappAccountId = item.account_id || item.accountId || ''
                }
            }
        },
        changeCloudType(value) {
            if(value == 'whatsapp'){
                this.headerText = 'WhatsApp'
                this.cloudType = value
                this.accountId = this.whatsappAccountId
                this.show_wp_integration = true
                this.showCards = false
            }else{
                this.cloudType = value
                if(value == 'im-sms' || value == 'im-email'){
                    this.show_im_integration = true

                    if(value == 'im-sms'){
                        this.headerText = 'İletişim Makinesi SMS'
                        if(this.im_sms_active == true){
                            this.updateMode = true
                        }
                    }
                    else{
                        this.headerText = 'İletişim Makinesi Mail'
                        if(this.im_mail_active == true){
                            this.updateMode = true
                        }
                    }
                    
                    for(let item of this.apiTokensList){
                        if(item.cloud_type === value){
                            this.accountId = item.account_id
                            this.accountName = item.account_name
                            this.accountEmail = item.account_email
                            this.iysBrandCode = item.cloud_api_token.iysBrandCode
                            this.iysRecipientType = item.cloud_api_token.iysRecipientType
                            this.iysTransactionType = item.cloud_api_token.iysTransactionType
                            this.originatorId = item.cloud_api_token.originatorId
                            this.token = item.cloud_api_token.token
                        }
                    }
                }
                this.showCards = false
            }
        },
        saveCloudApiTokenF(){
            let form = {}

            form.cloudType = this.cloudType
            form.accountName = this.accountName
            form.accountEmail = this.accountEmail
            form.cloudApiToken = {
                "iysBrandCode": this.iysBrandCode,
                "iysTransactionType": this.iysTransactionType,
                "iysRecipientType": this.iysRecipientType,
                "originatorId": this.originatorId,
                "token": this.token,
            }
            axios({
                method:'POST',
                url:'/saveCloudApiToken',
                baseURL: this.baseUrl,
                data: form,
                withCredentials:true
            }).then((res)=>{
                if(res.data.status && res.data.status.code == 0){
                    this.getCloudApiTokensF()
                    this.clear()
                }
            })
        },
        disconnectWhatsApp(){
            if(!this.whatsappAccountId){
                this.$notify({ group: 'foo', type: 'error', text: 'WhatsApp bağlantı kaydı bulunamadı.' })
                return
            }

            this.whatsappDisconnecting = true
            axios({
                method:'POST',
                url:'/deleteCloudApiToken',
                baseURL: this.baseUrl,
                data: { accountId: this.whatsappAccountId },
                withCredentials:true
            }).then((res)=>{
                if(res.data && res.data.status && String(res.data.status.code) === '0'){
                    this.$notify({ group: 'foo', type: 'success', text: 'WhatsApp bağlantısı kesildi.' })
                    this.getCloudApiTokensF()
                    this.clear()
                }else{
                    this.$notify({ group: 'foo', type: 'error', text: (res.data && res.data.status && res.data.status.desc) || 'WhatsApp bağlantısı kesilemedi.' })
                }
            }).catch(()=>{
                this.$notify({ group: 'foo', type: 'error', text: 'WhatsApp bağlantısı kesilemedi.' })
            }).finally(()=>{
                this.whatsappDisconnecting = false
            })
        },
        updateCloudApiTokenF(){
            let form = {}

            form.accountId = this.accountId
            form.cloudType = this.cloudType
            form.accountName = this.accountName
            form.accountEmail = this.accountEmail
            form.cloudApiToken = {
                "iysBrandCode": this.iysBrandCode,
                "iysTransactionType": this.iysTransactionType,
                "iysRecipientType": this.iysRecipientType,
                "originatorId": this.originatorId,
                "token": this.token,
            }

            axios({
                method:'POST',
                url:'/updateCloudApiToken',
                baseURL: this.baseUrl,
                data: form,
                withCredentials:true
            }).then((res)=>{
                if(res.data.status && res.data.status.code == 0){
                    this.getCloudApiTokensF()
                    this.clear()
                }
            })
        },
        getCloudApiTokensF(){
            axios({
                method:'get',
                url:'/getCloudApiTokens',
                baseURL: this.baseUrl,
                withCredentials:true
            }).then((res)=>{
                if(res.data.status && res.data.status.code == 0){     
                    this.apiTokensList = res.data.content.tokens 
                    this.checkIntegrations(res.data.content.tokens)
                    this.clear()
                }
            })
        },
        deleteCloudApiTokenF(){
            axios({
                method:'POST',
                url:'/deleteCloudApiToken',
                baseURL: this.baseUrl,
                data: {
                    accountId: this.accountId
                },
                withCredentials:true
            }).then((res)=>{
                if(res.data.status && res.data.status.code == 0){
                    if(this.cloudType == 'im-sms'){
                        this.im_sms_active = false
                    }
                    else if(this.cloudType == 'im-email'){
                        this.im_mail_active = false
                    }
                    this.clear()
                    this.getCloudApiTokensF()
                }
            })
        },
        clear() {
            this.accountName = ''
            this.cloudType = ''
            this.accountEmail = ''
            this.cloudApiToken = ''
            this.iysBrandCode = ''
            this.iysTransactionType = ''
            this.iysRecipientType = ''
            this.originatorId = ''
            this.token = ''
            this.showCards = true
            this.show_im_integration = false
            this.updateMode = false
            this.show_wp_integration = false
        }
    },
    mounted() {
        this.getCloudApiTokensF()
        window.addEventListener('message', this.handleMetaPopupMessage)

        document.addEventListener("fb-sdk-ready", () => {
            this.fbReady = true;
        });
        if (window.FB) {
            this.fbReady = true;
        }
    },
    beforeDestroy() {
        window.removeEventListener('message', this.handleMetaPopupMessage)
    }
}
</script>

<style scoped>
    .grid-item {
        position: relative;
        max-width: 255px;
        background-color: #FFFFFF;
        box-shadow: 0px 2px 6px rgba(176, 186, 197, 0.6);
        border: 1px solid transparent;
        border-radius: 4px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 10px;
    }
    .grid-item:hover {
        border: 1px solid #D8D6D6;
        cursor: pointer;
    }
    .card-active {
        position: absolute;
        top: 3%;
        right: 3%;
        font-size: 12px;
    }
    .wp-option-card {
        background-color: #FFFFFF;
        border: 1px solid #E2E8F0;
        border-radius: 6px;
        box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.05);
    }
</style>